module.exports = __webpack_public_path__ + "static/media/git.838cf58c.svg";